// Copied code from conversation-assistant-service/src/common/utils/fetch.ts

import { FetchError } from './fetch-error';
import type { RovoInstrumentedError } from './rovo-instrumented-error';
import { getTraceIdFromResponse } from './trace-id-from-response';

type FetchOptions = {
	path: string;
	options: RequestInit;
};

/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */
class HttpApiError extends Error implements RovoInstrumentedError {
	constructor(
		public message: string,
		public errorAttributes: {
			statusCode: number;
			traceId?: string;
			requestId?: string;
			rawErrorMessage?: string;
			errorCode?: string;
		},
	) {
		super(message);
	}
}

/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */
export const performHttpFetch = async ({ path, options }: FetchOptions) => {
	try {
		const response = await fetch(path, options);
		if (!response.ok || response.status >= 400) {
			await processHttpErrorResponse({ response });
		}
		return await response.json();
	} catch (err) {
		const originalErrorMessage =
			err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
		throw new FetchError(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
			errorCode: 'performHttpFetchError',
		});
	}
};

/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */
const processHttpErrorResponse = async ({
	response,
}: {
	response: Response;
}): Promise<Response> => {
	throw new HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
		statusCode: response.status,
		traceId: getTraceIdFromResponse(response),
	});
};
